import React, { useState, useEffect } from 'react'
import { Box, SimpleGrid, NumberInput, Flex, Group, Button, Text, Checkbox } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrderCustomCharges } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { calculation } from '../../../../../services/calculation'
import { validation } from '../../../../../plugins/validation'

const defaultVal = {
  total_duty: null,
  total_wht: null,
  total_vat: null,
  revised_total_duty: 0,
  revised_total_vat: 0,
  revised_total_wht: 0,
}

const defaultUseRevised = {
  duty: false,
  wht: false,
  vat: false
}

const formValidation = {
  revised_total_duty: {
    isError: false,
    message: ''
  },
  revised_total_wht: {
    isError: false,
    message: ''
  },
  revised_total_vat: {
    isError: false,
    message: ''
  }
  
}

const FormAdjustCustomCharge = ({ dataCharges, onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [useRevised, setUseRevised] = useState(defaultUseRevised)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitCustomCharge = async (form, statusRevised) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    // bypass validation
    const validateForm = {
      revised_total_duty: statusRevised.duty ? `${form.revised_total_duty}` : '0',
      revised_total_vat: statusRevised.vat ? `${form.revised_total_vat}` : '0',
      revised_total_wht: statusRevised.wht ? `${form.revised_total_wht}` : '0',
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payload = {
      revised_total_duty: statusRevised.duty ? form.revised_total_duty : 0,
      revised_total_vat: statusRevised.vat ? form.revised_total_vat : 0,
      revised_total_wht: statusRevised.wht ? form.revised_total_wht : 0,
    }
    try {
      const response = await updateOrderCustomCharges(orderId, dataCharges.customs_charge_id, payload)
      if (response.success) {
        notificationSuccess('Update Order Successfully', 'This data has been updated')
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          onCloseForm()
          dispatch(getOrderDetail(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataCharges) {
      handleSetForm(dataCharges)
    }
    // eslint-disable-next-line
  }, [dataCharges])

  const handleSetForm = (value) => {
    console.log(value)
    const dataDetail = {
      total_duty: value.total_duty,
      total_wht: value.total_wht,
      total_vat: value.total_vat,
      revised_total_duty: Number(value.revised_total_duty) > 0 ? Number(value.revised_total_duty) : '',
      revised_total_vat: Number(value.revised_total_vat) > 0? Number(value.revised_total_vat) : '',
      revised_total_wht: Number(value.revised_total_wht) > 0? Number(value.revised_total_wht) : '',
    }

    const statusRevised = {
      duty: value.revised_total_duty > 0 ? true : false,
      wht: value.revised_total_wht > 0 ? true : false,
      vat: value.revised_total_vat > 0 ? true : false,
    }
    setFormData(dataDetail)
    setUseRevised(statusRevised)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleChangeStatusRevised = (name, val) => {
    setUseRevised((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
        <Box>
          <Box mb='xs'>
            <NumberInput
              name='total_duty'
              label="BM / Duty"
              value={formData.total_duty}
              leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
              size='xs'
              thousandSeparator=","
              decimalSeparator='.'
              decimalScale={2}
              leftSectionWidth={40}
              disabled
            />
          </Box>
          <Box mb='md'>
            <Checkbox
              checked={useRevised.duty}
              labelPosition="right"
              size='xs'
              onChange={(val) => handleChangeStatusRevised('duty', val.currentTarget.checked)}    
              label="Use Revised BM / Duty"
            />
          </Box>
          <Box mb='xs'>
            <NumberInput
              name='total_wht'
              label="PPH / WHT"
              value={formData.total_wht}
              leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
              size='xs'
              thousandSeparator=","
              decimalSeparator='.'
              decimalScale={2}
              leftSectionWidth={40}
              disabled
            />
          </Box>
          <Box mb='md'>
            <Checkbox
              checked={useRevised.wht}
              labelPosition="right"
              size='xs'
              onChange={(val) => handleChangeStatusRevised('wht', val.currentTarget.checked)}   
              label="Use Revised PPH / WHT"
            />
          </Box>
          <Box mb='xs'>
            <NumberInput
              name='total_vat'
              label="PPN / VAT"
              value={formData.total_vat}
              leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
              size='xs'
              thousandSeparator=","
              decimalSeparator='.'
              decimalScale={2}
              leftSectionWidth={40}
              disabled
            />
          </Box>
          <Box mb='md'>
            <Checkbox
              checked={useRevised.vat}
              labelPosition="right"
              size='xs'
              onChange={(val) => handleChangeStatusRevised('vat', val.currentTarget.checked)}     
              label="Use Revised PPN / VAT"
            />
          </Box>
        </Box>
        <Box>
          <Box h={97}>
            <NumberInput
              name='revised_total_duty'
              label="Revised BM / Duty"
              value={formData.revised_total_duty}
              leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
              size='xs'
              placeholder='Input Revised BM / Duty'
              onChange={(val) => handleChangeForm('revised_total_duty', val)}
              error={validationForm.revised_total_duty.isError ? `${validationForm.revised_total_duty.message}` : ''}
              withAsterisk
              thousandSeparator=","
              decimalSeparator='.'
              decimalScale={2}
              leftSectionWidth={40}
              disabled={!useRevised.duty}
            />
          </Box>
          <Box h={97}>
            <NumberInput
              name='revised_total_wht'
              label="Revised PPH / WHT"
              value={formData.revised_total_wht}
              leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
              size='xs'
              placeholder='Input Revised PPH / WHT'
              onChange={(val) => handleChangeForm('revised_total_wht', val)}
              error={validationForm.revised_total_wht.isError ? `${validationForm.revised_total_wht.message}` : ''}
              withAsterisk
              thousandSeparator=","
              decimalSeparator='.'
              decimalScale={2}
              leftSectionWidth={40}
              disabled={!useRevised.wht}
            />
          </Box>
          <Box h={97}>
            <NumberInput
              name='revised_total_vat'
              label="Revised PPN / VAT"
              value={formData.revised_total_vat}
              leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
              size='xs'
              placeholder='Input Revised PPN / VAT'
              onChange={(val) => handleChangeForm('revised_total_vat', val)}
              error={validationForm.revised_total_vat.isError ? `${validationForm.revised_total_vat.message}` : ''}
              withAsterisk
              thousandSeparator=","
              decimalSeparator='.'
              decimalScale={2}
              leftSectionWidth={40}
              disabled={!useRevised.vat}
            />
          </Box>
        </Box>
      </SimpleGrid>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitCustomCharge(formData, useRevised)}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustCustomCharge